import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PagedList, ProductSplitAvailableShapeModel, ProductSplitDefinitionFullModel, ProductSplitDefinitionModel } from '../interface';
import { ProductShortModel, ProductSplitDefinitionResourceService } from '../vn-api';

export interface ProductSplitDefinitionRequest {
  id: number;
  inProductInfoId: number;
  outProductInfoId: number;
  splitQuantity: number;
  shape: string;
  inProductSize: string;
}

@Injectable({
  providedIn: 'root'
})
export class HxProductSplitDefinitionService {
  constructor(
    private api: ProductSplitDefinitionResourceService,
  ) {
  }

  getProductSplitDefinitions(params?: {limit?: number; page?: number; inProductInfoId?: number; outProductInfoId?: number}): Observable<PagedList<ProductSplitDefinitionFullModel>> {
    return this.api.getProductSplitDefinitions(params?.inProductInfoId, params?.limit, params?.outProductInfoId, params?.page) as unknown as Observable<PagedList<ProductSplitDefinitionFullModel>>;
  }

  getProductSplitDefinitionById(id: number): Observable<ProductSplitDefinitionFullModel> {
    return this.api.getProductSplitDefinitionById(id) as unknown as Observable<ProductSplitDefinitionFullModel>;
  }

  saveProductSplitDefinition(body: Partial<ProductSplitDefinitionRequest>): Observable<ProductSplitDefinitionModel> {
    return this.api.saveProductSplitDefinition(body as any) as unknown as Observable<ProductSplitDefinitionModel>;
  }

  deleteProductSplitDefinitionById(id: number): Observable<ProductSplitDefinitionModel> {
    return this.api.removeProductSplitDefinitionById(id) as unknown as Observable<ProductSplitDefinitionModel>;
  }

  getActiveCart(params?: { storeId?: number }): Observable<ProductShortModel> {
    return this.api.getSplitActiveCart(params?.storeId as number);
  }

  cancelActiveCart(): Observable<void> {
    return this.api.cancelSplitActiveCart();
  }

  getAvailableShapes(params?: { productSplitDefinitionId?: number }): Observable<ProductSplitAvailableShapeModel> {
    return this.api.getAvailableShapes(params?.productSplitDefinitionId as number) as unknown as Observable<ProductSplitAvailableShapeModel>;
  }

  splitProcess(body: {productSplitDefinitionId: number, shapes: string[]}): Observable<void> {
    return this.api.splitProcess(body as any);
  }
}
